import React from 'react'
import styled from 'styled-components'
import CalendarBadge from './CalendarBadge'
import moment from 'moment-timezone'
import 'moment-timezone';
import { useCongress } from '../../../congress/hooks'

export default function Card ({ startsAt, endsAt, name, description, location }) {
  const { congress } = useCongress()

  let startsAtTime = moment(startsAt).tz(congress.Location).format('HH:mm');
  let endsAtTime = moment(endsAt).tz(congress.Location).format('HH:mm');
  return (
    <Container>
      <Dot />
      <Header>
        <InfoContainer>
          <ActivityTitle>{name}</ActivityTitle>
          <Time color="#19A0FA">
            {startsAtTime} - {endsAtTime}
          </Time>
        </InfoContainer>

        <CalendarBadge number={moment(startsAt).format('DD')} month={moment(startsAt).format('MMM')}/>
      </Header>

      {description ? (
        <Description>
          {description}
        </Description>
      ) : null}

      <Location color="#19A0FA">
        {location}
      </Location>
    </Container>
  )
}

const Container = styled.div`
  background-color: #ffffff;
  padding: 13px 16px;
  border-radius: 12px;
  box-shadow: 0 6px 19px rgba(41, 76, 143, 0.19);
  margin: 20px 10px;
`
const Dot = styled.div`
  width: 17px;
  height: 17px;
  border-radius: 9px;
  background-color: #77AE49;
  position: absolute;
  margin: 10px 0 0 -25px;
`

const Header = styled.div`
  display: flex;
  flex-direction: row;
`

const InfoContainer = styled.div`
  flex: 1;
  margin-right: 12px;
`

const ActivityTitle = styled.p`
  font-weight: bold;
  font-size: 16px;
`

const Time = styled.p`
  font-weight: 600;
  font-size: 16px;
  margin-top: 6px;
  color: ${props => props.color};
`

const Description = styled.p`
  color: #363636;
  margin-top: 16px;
  line-height: 20px;
`

const Location = styled.p`
  text-align: right;
  color: ${props => props.color};
`
